import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getPackingList(params) {
  return request({
    url: URL.mdm.basicData.packing,
    method: 'get',
    params
  })
}

export function getPackingsByPlatform(params) {
  return request({
    url: URL.mdm.basicData.platformPacking,
    method: 'get',
    params
  })
}

export function getAllPackingTemplate(params) {
  return request({
    url: URL.mdm.basicData.packingTemplate,
    method: 'get',
    params
  })
}

export function savePacking(data) {
  return request({
    url: URL.mdm.basicData.packing,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addPackingByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformPacking,
    method: 'post',
    data
  })
}

export function savePackings(data) {
  return request({
    url: URL.mdm.basicData.packings,
    method: 'post',
    data
  })
}

export function delPacking(uuid) {
  return request({
    url: URL.mdm.basicData.packing + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

// 检验接收方是否维护对应的包装
export function isHavePacking(tenantId, code) {
  return request({
    url: URL.mdm.basicData.isHavePacking,
    method: 'get',
    params: { tenantId, code }
  })
}
